import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Solutions from '../components/Solutions';
import Features from '../components/Features';
import Process from '../components/Process';
import Technologies from '../components/Technologies';
import CTA from '../components/CTA';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <Solutions />
      <Features />
      <Process />
      <Technologies />
      <CTA />
      <Contact />
    </>
  );
};

export default Home;
